// extracted by mini-css-extract-plugin
export default {"link":"TopTitleBlock_link__HesO4","pagination":"TopTitleBlock_pagination__f0uCS"};